import { defineMessages } from 'react-intl';

export const teamAccessMessages = defineMessages({
  deniedTitle: {
    id: 'membersV2.orgAccessDeniedTitle',
    defaultMessage: "You don't have access to this organization.",
    description: 'Title shown when the user lacks access to the requested team organization',
  },
  deniedDescription: {
    id: 'membersV2.orgAccessDeniedBody',
    defaultMessage:
      'Contact your organization administrator or switch organizations to view a team you can access.',
    description: 'Description shown when the user lacks access to the requested team organization',
  },
});
